module.exports = __webpack_public_path__ + "img/i-max.ac5332fb.png";